import React, { useEffect } from 'react';
import { SOURCE_AND_DEVICE_TYPE } from '../../constants';
import {
  getSourceAndDeviceType,
  isNotLoginOrRegisterPath,
} from '../../helpers';
import Header from './Header';
import UseSyncSoComAffiliateWithBag from '../../hooks/useSyncSoComAffiliateWithBag/useSyncSoComAffiliateWithBag';
import useDeviceTypeListener from '../../hooks/useDeviceTypeListener/useDeviceTypeListener';
import { useHeaderUpdateSubscription } from '../../hooks/useHeaderUpdateSubscription/useHeaderUpdateSubscription';
import { useWindowFlag } from '../../hooks/useWindowFlag/useWindowFlag';

function HeaderVM() {
  const deviceType = useDeviceTypeListener();
  const memberWalletHeader = !!useWindowFlag('MemberWallet');
  const memberWalletEnhancement = !!useWindowFlag('MemberWalletEnhancement');
  const addToBagFlyoutEnabled = !!useWindowFlag('AddToBagFlyout');

  /**
   * Subscribe to the customer-status-change-event that is thrown by the
   * main app after a login or logout.
   */
  const count = useHeaderUpdateSubscription();

  useEffect(() => {
    // make this useEffect run on the client and not the server
    if (typeof window !== 'undefined') {
      const isValidPathname = isNotLoginOrRegisterPath(
        window.location.pathname,
      );
      if (isValidPathname) {
        const sourceAndDeviceType = getSourceAndDeviceType(
          SOURCE_AND_DEVICE_TYPE,
          deviceType,
          window.location.pathname,
        );

        window.sessionStorage.setItem(
          'OriginRoutePathnameToCreate',
          sourceAndDeviceType,
        );
      }
    }
  }, [deviceType]);

  UseSyncSoComAffiliateWithBag();

  return (
    <Header
      data-count={count}
      memberWalletHeader={memberWalletHeader}
      memberWalletEnhancement={memberWalletEnhancement}
      addToBagFlyoutEnabled={addToBagFlyoutEnabled}
    />
  );
}

export default HeaderVM;
